import angular from 'angular';

const thumbnails3d = angular.module('thumbnails3d', ['thumbnails3dTemplates']);

export default thumbnails3d;
